var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "painel-orquestrador az-gap-small" }, [
    _c(
      "div",
      { staticClass: "az-ds-label-sentenca painel-orquestrador__titulo" },
      [_vm._v(" " + _vm._s(_vm.titulo) + " ")]
    ),
    _c(
      "div",
      { staticClass: "painel-orquestrador__bloco az-gap-xsmall" },
      [
        _c(
          "div",
          { staticClass: "d-flex align-center flex-wrap az-gap-small" },
          [
            _c("icon-svg", {
              staticClass: "flex-shrink-0",
              attrs: {
                name: _vm.orquestrador.icone,
                size: 16,
                color: "primary"
              }
            }),
            _c(
              "span",
              { staticClass: "az-text-primary az-size-12 font-medium" },
              [_vm._v(_vm._s(_vm.orquestrador.rotulo))]
            ),
            _vm.orquestrador.ehFallback
              ? _c("BaseStatus", {
                  attrs: {
                    soft: "",
                    "preserve-case": "",
                    content: _vm.orquestrador.aviso,
                    color: "warning-new"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm.orquestrador.explicacao
          ? _c(
              "div",
              { staticClass: "az-text-secondary az-size-12 az-muted" },
              [_vm._v(" " + _vm._s(_vm.orquestrador.explicacao) + " ")]
            )
          : _vm._e(),
        _vm.opcoes.length
          ? _c(
              "div",
              { staticClass: "painel-orquestrador__opcoes az-gap-xsmall" },
              [
                _c(
                  "span",
                  { staticClass: "az-text-primary az-size-12 font-medium" },
                  [_vm._v("Opções avaliadas")]
                ),
                _c("AdvisoryOpcoesTabela", { attrs: { opcoes: _vm.opcoes } })
              ],
              1
            )
          : _vm._e(),
        _vm.orquestrador.posicaoConsolidada
          ? _c(
              "div",
              {
                staticClass:
                  "az-text-secondary az-size-12 painel-orquestrador__prosa"
              },
              [_vm._v(" " + _vm._s(_vm.orquestrador.posicaoConsolidada) + " ")]
            )
          : _vm._e(),
        _vm._l(_vm.orquestrador.porArea, function(area) {
          return _c(
            "div",
            {
              key: area.chave,
              staticClass: "painel-orquestrador__secao az-gap-xsmall"
            },
            [
              _c(
                "span",
                { staticClass: "az-text-primary az-size-12 font-medium" },
                [_vm._v(_vm._s(area.label))]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "az-text-secondary az-size-12 painel-orquestrador__posicao"
                },
                [_vm._v(" " + _vm._s(area.posicao) + " ")]
              ),
              area.temFundamentos
                ? _c(
                    "button",
                    {
                      staticClass:
                        "az-ds-hyperlink painel-orquestrador__ver-fundamentos ia-texto-auxiliar",
                      attrs: {
                        type: "button",
                        "aria-expanded": String(
                          Boolean(_vm.expandidos[area.chave])
                        ),
                        "aria-label":
                          _vm.rotulosDeFundamentos[area.chave] +
                          " de " +
                          area.label
                      },
                      on: {
                        click: function($event) {
                          return _vm.alternarArea(area.chave)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.rotulosDeFundamentos[area.chave]))
                      ]),
                      _c("icon-svg", {
                        staticClass: "ia-block-seta",
                        class: _vm.expandidos[area.chave]
                          ? "ia-block-seta--aberta"
                          : "",
                        attrs: {
                          name: "arrow-down-new-ux",
                          size: 12,
                          color: "var(--primary)"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-expand-transition", [
                _vm.expandidos[area.chave]
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "painel-orquestrador__fundamentos az-gap-xsmall"
                      },
                      _vm._l(area.fundamentos, function(fundamento) {
                        return _c(
                          "div",
                          {
                            key: fundamento.chave,
                            staticClass: "painel-orquestrador__fundamento"
                          },
                          [
                            fundamento.afirmacao
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "az-text-secondary az-size-12"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(fundamento.afirmacao) + " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            fundamento.fonte
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-secondary az-size-12 az-muted"
                                  },
                                  [
                                    _vm._v(
                                      " — " + _vm._s(fundamento.fonte) + " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        }),
        _vm._l(_vm.orquestrador.secoes, function(secao) {
          return _c(
            "div",
            {
              key: secao.chave,
              staticClass: "painel-orquestrador__secao az-gap-xsmall"
            },
            [
              _c(
                "div",
                { staticClass: "az-text-primary az-size-12 font-medium" },
                [_vm._v(_vm._s(secao.titulo))]
              ),
              _vm._l(secao.itens, function(item) {
                return _c(
                  "div",
                  {
                    key: item.chave,
                    staticClass: "az-text-secondary az-size-12"
                  },
                  [_vm._v(" " + _vm._s(item.texto) + " ")]
                )
              })
            ],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }